<template>
  <div class="modal" :class="{'modal_active': activeX}" v-if="activeX">
    <div class="modal__overlay" @click="activeX = false"></div>
    <div class="modal__wrapper">
      <div class="modal__body" :style="{width: width || 'auto'}">
        <div class="modal__header">
          <div class="modal__title">
            {{title}}
          </div>
          <feather-icon icon="XIcon" class="modal__close" @click="activeX = false"/>
        </div>
        <div class="modal__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AppPopup",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: "Modal"
      },
      width: {

      }
    },
    computed: {
      activeX: {
        get(){
          return this.active;
        },
        set(value){
          this.$emit('update:active', value)
        }
      }
    }
  }
</script>

<style lang="scss">
  .modal{
    position: fixed;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;

    .modal__overlay{
      position: absolute;
      background-color: #000;
      animation: modal-background .4s ease-out 1 both;
      content: "";
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    &__wrapper{
      display: inline-block;
      width: 100%;
      height: 100vh;
      overflow: auto;
      white-space: nowrap;
      text-align: center;

      &::before{
        content: "";
        height: 100%;
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__body{
      display: inline-flex;
      flex-direction: column;
      vertical-align: middle;
      position: relative;
      z-index: 101;
      min-width: 290px;
      max-width: calc(100% - 30px);
      max-height: calc(100% - 30px);
      margin: 15px;
      white-space: normal;
      text-align: left;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 10px 12px rgba(0,0,0,.2);
      transition: width .3s ease-out;
      animation: modal-move .4s ease-out 1 both;
    }

    &__content{
      padding: 1rem;
      flex: 1;
      overflow: auto;
      /*display: flex;*/
      /*flex-direction: column;*/
      position: relative;
    }

    &__header{
      width: 100%;
      flex: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(0, 0, 0, .05);
      position: relative;
      padding: 8px;
    }

    &__title{
      width: 100%;
      position: relative;
      overflow: hidden;
      transition: all .23s ease .1s;
      padding-right: 5px;
      font-size: 1.2rem;
      font-weight: 500;
    }

    &__close{
      width: 1.5rem;
      height: 1.5rem;
      svg{
        width: 100%;
        height: 100%;
      }

      &:hover{
        color: black;
        cursor: pointer;
      }
    }
  }



  @keyframes modal-move {
    0%{
      transform: translateY(-25%);
      opacity: .2;
    }

    100%{
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes modal-background {
    0%{
      opacity: .02;
    }

    100%{
      opacity: .2;
    }
  }
</style>